import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function MoneyOffIcon(props: IconProps) {
    return <Icon {...props} iconKey={"money_off"}/>
}
